module.exports = __webpack_public_path__ + "img/10.c13b73df.svg";